import { render, staticRenderFns } from "./AfterSalesInfo.vue?vue&type=template&id=2a91cc9a&scoped=true"
import script from "./AfterSalesInfo.vue?vue&type=script&lang=js"
export * from "./AfterSalesInfo.vue?vue&type=script&lang=js"
import style0 from "./AfterSalesInfo.vue?vue&type=style&index=0&id=2a91cc9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a91cc9a",
  null
  
)

export default component.exports